export default "__VITE_ASSET__8f49002d__"